<template>
  <div class="main card">
    <div class="header">
      <div class="title">اضافه کردن سرفصل</div>
      <div class="option">
        <div @click="$bvModal.show('deleteModal')" class="delete">
          <img src="../../../assets/images/dadbanan/delete.svg" />
          <span>حذف</span>
        </div>
        <div class="view" @click="goHeadlineDetail">
          <img src="../../../assets/images/dadbanan/view.svg" alt="" />
          <span>نمایش</span>
        </div>
      </div>
    </div>
    <div class="form">
      <div class="mt-5">
        <BaseText :maxlength="2000" :value="model.title" @input="model.title = $event" title="عنوان" placeholder="عنوان" />
      </div>
      <div class="my-4">
        <EditorInput :value="model.description" @input="model.description = $event" title="توضیحات" :hasImage="false" textAreaClass="align-items-center" />
      </div>
      <div class="display">
        <div class="display-title">نحوه نمایش</div>
        <Radio :componentData="displayTypes" :value="model.displayType" @input="model.displayType = $event" />
      </div>
      <div class="p-3 d-flex flex-row justify-content-end mt-5">
        <b-button variant="outline-secondary" @click="$router.go(-1)">انصراف</b-button>
        <Button @click.native="createHeadline" :loading="submitLoading" text="ثبت" btnClass="upload-btn btn-border" />
      </div>
    </div>
    <Toast :title="toastText" :showToast="showToast" :error="error" />
    <b-modal id="deleteModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="@/assets/images/checked1.svg" />
        </div>
        <div class="error-title text-center">آیا از حذف این سرفصل اطمینان دارید؟</div>
        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button class="col-6" variant="secondary" block @click="$bvModal.hide('deleteModal')">خیر</b-button>
            <b-button class="ms-2 col-6" variant="primary" block @click="deleteHeadline">بله</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import EditorInput from '../../common/form/formModules/editorInput.vue'
import Radio from '../../common/form/formModules/Radio.vue'
import dadbanCourseSessionProvider from '../../../services/dadban/healline'
import Toast from '../../common/Toast.vue'
import Button from '../../common/Button.vue'

export default {
  components: { BaseText, EditorInput, Radio, Toast, Button },
  props: {
    update: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Number,
      default: 0,
    },
    default: {
      type: Object,
    },
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: {
        courseId: +this.$route.params.courseId,
        title: '',
        description: '',
        displayType: 1,
        order: 0,
      },
      displayTypes: [
        { key: 1, value: 'پیش نویس' },
        { key: 2, value: 'عمومی' },
        { key: 3, value: 'به زودی' },
      ],
      lastOrder: 0,
      showToast: false,
      toastText: 'با موفقیت ثبت شد',
      error: false,
      submitLoading: false,
    }
  },
  watch: {
    '$route.query'(c) {
      if (!c) {
        for (const key in this.model) {
          this.model[key] = ''
        }
      }
    },
    clear(c) {
      if (c) {
        for (const key in this.model) {
          this.model[key] = ''
          this.model.displayType = 1
        }
      }
    },
  },
  mounted() {
    if (this.default && this.$route.query.id) {
      this.model = this.default
    }
  },
  methods: {
    async createHeadline() {
      try {
        this.model.courseId = +this.$route.params.courseId
        if (this.$route.query.id) {
          this.submitLoading = true
          const req = await dadbanCourseSessionProvider.updateCourseSession(this.model)
          if (req.status === 200) {
            this.showToast = true
          }
          this.$emit('update')
          this.submitLoading = false
          return false
        }
        this.model.order = +this.order + 1
        if (this.model.title) {
          this.submitLoading = true
          const req = await dadbanCourseSessionProvider.addCourseSession(this.model)
          if (req.status === 200) {
            this.showToast = true
          }
          this.$emit('update')
          for (const key in this.model) {
            this.model[key] = ''
            this.model.displayType = 1
          }
          this.submitLoading = false
        } else {
          this.submitLoading = false
          this.error = true
          this.toastText = 'لطفا عنوان سرفصل را وارد نمایید'
          this.showToast = true
          setTimeout(() => {
            this.error = false
            this.toastText = 'ثبت با موفقیت انجام شد'
            this.showToast = false
          }, 5000)
        }
      } catch (error) {
        this.submitLoading = false
        this.error = true
        this.toastText = 'خطا! لطفا دوباره تلاش کنید'
        this.showToast = true
        setTimeout(() => {
          this.error = false
          this.toastText = 'ثبت با موفقیت انجام شد'
          this.showToast = false
        }, 5000)
      }
    },
    async deleteHeadline() {
      const req = await dadbanCourseSessionProvider.deleteCourseSession(+this.$route.query.id)
      if (req.status === 200) {
        this.$bvModal.hide('deleteModal')
        this.$emit('update')
        this.$router.push(this.$route.path)
      }
    },
    async goHeadlineDetail() {
      let token = await dadbanCourseSessionProvider.generateToken()
      token = token.data.data.token
      window.open(`https://dadbanan.cloudware.ir/show-headlines/${this.$route.params.courseId}?headlineId=${this.$route.query.id}&token=${token}`, '_black')
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  .title {
    font-weight: 400;
    font-size: 18px;
    line-height: 15px;
    color: #4e4e56;
  }

  .option {
    display: flex;
  }
  .delete {
    background: rgba(244, 106, 106, 0.2);
    border-radius: 4px;
    display: flex;
    padding: 5px 10px;
    cursor: pointer;
    margin-left: 10px;
    span {
      color: #f46a6a;
      font-size: 14px;
      font-weight: 400;
      margin-right: 5px;
    }
  }

  .view {
    @extend .delete;
    background: rgba(52, 195, 143, 0.2);
    span {
      color: #34c38f;
    }
  }
}

.display-title {
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  color: #495057;
}
::v-deep .bv-no-focus-ring {
  display: flex;
  flex-direction: row !important;
}

::v-deep .custom-control-inline {
  margin-left: 80px;
}

::v-deep .custom-control-label {
  margin-right: 10px;
}

.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}

::v-deep .labelStyle {
  margin-left: 0;
  min-width: 88px;
}
</style>
